import { styled } from '@mui/material';

export const CheckboxListTitle = styled('h3')`
  font-weight: bolder;
  font-size: 0.875rem;
  padding-bottom: 13px;
`;
